export default __webpack_public_path__ + "static/media/GunHaiMap.69534163.jpg";